export const ROOT = 'table-component';

export const INSERT_TABLE_BUTTON = 'insert-table-button';
export const INSERT_TABLE_MODAL = 'insert-table-modal';
export const INSERT_TABLE_MODAL_ROWS_INPUT = 'insert-table-modal-row-count';
export const INSERT_TABLE_MODAL_COLUMNS_INPUT = 'insert-table-modal-column-count';
export const INSERT_TABLE_MODAL_ERROR_MESSAGE = 'insert-table-modal-error-message';
export const INSERT_TABLE_MODAL_FOOTER_ACTIONS = 'insert-table-modal-footer-actions';

export const TABLE_PLUS_BUTTON = 'table-plus-button';
export const TABLE_PLUGIN_CELL = 'table-plugin-cell';

export const PLUGIN_TOOLBAR_FORMATTING_BUTTON = 'plugin-toolbar-text-style-button';
export const PLUGIN_TOOLBAR_VERTICAL_ALIGNMENT_BUTTON = 'plugin-toolbar-vertical-alignment-button';
export const PLUGIN_TOOLBAR_BACKGROUND_COLOR_BUTTON = 'plugin-toolbar-background-color-button';
export const PLUGIN_TOOLBAR_BORDER_COLOR_BUTTON = 'plugin-toolbar-border-color-button';
export const PLUGIN_TOOLBAR_CONTEXT_MENU_BUTTON = 'plugin-toolbar-context-menu-button';
export const PLUGIN_TOOLBAR_ROW_HEADER_BUTTON = 'plugin-toolbar-row-header-button';
export const PLUGIN_TOOLBAR_COLUMN_HEADER_BUTTON = 'plugin-toolbar-column-header-button';
